module.exports = __webpack_public_path__ + "img/sb_ashley_tag.8dadd60.svg";